import React, {FC} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import styles from './AppHeader.css';

interface AppHeaderProps {
	mode: 'general' | 'ads';
}

export const AppHeader: FC<AppHeaderProps> = props => {
	const {mode} = props;
	const t = useLocalizer();

	return (
		<header className={styles.root}>
			<div className={styles.logoLine}>
				<a className={styles.logo} href='/' aria-label={t('mainPageLabel')} />
			</div>
			<h1 className={styles.title}>{t(`pageTitle.${mode}`)}</h1>
			<h2 className={styles.subtitle}>{t(`pageSubtitle.${mode}`)}</h2>
		</header>
	);
};

AppHeader.displayName = 'AppHeader';
